/**
 * @file AdminRoute.js
 * @description Ruta protegida que sólo permite el acceso a usuarios con rol admin.
 * Si el usuario no está autenticado o no es admin, se le redirige al área de
 * Ecotrim (o al login si no hay sesión).
 *
 * Usado para restringir las secciones de Autoconsumo Colectivo (IT-113) a
 * usuarios administradores.
 */

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { ClientAreaSkeleton } from '../Skeletons';

const AdminRoute = ({ children, redirectTo = '/ecotrim-area' }) => {
  const { isAuthenticated, isAdmin, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading) return;
    if (!isAuthenticated) {
      navigate('/login', { replace: true });
      return;
    }
    if (!isAdmin) {
      navigate(redirectTo, { replace: true });
    }
  }, [isAuthenticated, isAdmin, isLoading, navigate, redirectTo]);

  if (isLoading && !isAuthenticated) {
    return <ClientAreaSkeleton variant="dashboard" />;
  }

  if (!isAuthenticated || !isAdmin) {
    return null;
  }

  return <>{children}</>;
};

export default AdminRoute;
